export * from './lib/services/dialogs.service';
export * from './lib/interfaces/confirm-dialog-config.interfaces';
export * from './lib/components/confirm-dialog/confirm-dialog.component';
export * from './lib/components/name-dialog/name-dialog.component';
export * from './lib/components/timeout-dialog/timeout-dialog.component';

export * from './lib/dialog.module';
